import { render } from "./HomBlocosHomeMobileView.vue?vue&type=template&id=3b0f74ee&scoped=true"
import script from "./HomBlocosHomeMobileView.vue?vue&type=script&lang=js"
export * from "./HomBlocosHomeMobileView.vue?vue&type=script&lang=js"

import "./HomBlocosHomeMobileView.vue?vue&type=style&index=0&id=3b0f74ee&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0f74ee"]])

export default __exports__